import ExamArrangeSelector from './src/main';

/* istanbul ignore next */
ExamArrangeSelector.install = function(Vue) {
  Vue.component(ExamArrangeSelector.name, ExamArrangeSelector);
};

export default ExamArrangeSelector;
